import { useMemo } from 'react';
import MantineTable from '../../../../common/table/mantine';

export const PreviewTable = ({
  data,
  columns,
  dependencies = [],
  enableZoom = false,
  zoom = 0.75,
}) => {
  let memonizedColumns = useMemo(() => columns, dependencies ? [data, ...dependencies] : [data]);
  return (
    <MantineTable
      columns={memonizedColumns}
      initialData={data}
      enablePagination={false}
      enableSorting={true}
      enableBottomToolbar={false}
      enableTopToolbar={false}
      loading={false}
      enableColumnFilters={false}
      enableColumnActions={false}
      enableZoom={enableZoom}
      zoom={zoom}
      mantineTableHeadProps={{
        sx: {
          '& tr': {
            backgroundColor: '#D8D8D8',

            '& .mantine-TableHeadCell-Content': {
              color: '#1E1E1E',
            },
          },
        },
      }}
    />
  );
};
